// extracted by mini-css-extract-plugin
module.exports = {"info":"footer-info_info__C48hQ"};